import { FETCH_SERVICE_PACKAGES, SET_SERVICE_PACKAGES } from '@/store/types';
// eslint-disable-next-line import/no-cycle
import { handleRequests } from '@/helpers/index';

const INIT_STATE = () => ({
    servicePackages: []
});

const getters = {
    getServicePackages: (state) => {
        return state.servicePackages;
    }
};

const mutations = {
    [SET_SERVICE_PACKAGES]: (state, payload) => {
        state.servicePackages = payload;
    }
};

const actions = {
    async [FETCH_SERVICE_PACKAGES]({ commit }) {
        const endpoint = `/api/rate-groups/rateRules`;
        const response = await handleRequests(endpoint);

        let transFormedData = [];

        if (response !== null && response.data !== null) {
            transFormedData = response.data.map((rg) => {
                return {
                    rateGroupId: rg.rateGroupId,
                    rateGroupName: rg.rateGroupName,
                    rateGroupType: rg.ruleType
                };
            });
            commit(SET_SERVICE_PACKAGES, transFormedData);
        }

        return transFormedData;
    }
};

const state = () => ({ ...INIT_STATE() });

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
